import { render } from "./AdminPromoCodeEdit.vue?vue&type=template&id=fbdd2f4e&scoped=true&ts=true"
import script from "./AdminPromoCodeEdit.vue?vue&type=script&lang=ts"
export * from "./AdminPromoCodeEdit.vue?vue&type=script&lang=ts"

import "./AdminPromoCodeEdit.vue?vue&type=style&index=0&id=fbdd2f4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fbdd2f4e"]])

export default __exports__